import React from "react";
import { useParams } from "react-router-dom";
import SwitchCourseBoard from "../../../../../components/montessori-course-board/SwitchCourseBoard";

/**
 * Admin board view. Authoring controls come from the shared component's own role
 * check, so there is nothing to pass here beyond the class.
 */
function AdminCourseBoardView() {
  const { classId } = useParams();
  return <SwitchCourseBoard classId={classId} />;
}

export default AdminCourseBoardView;
